import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isShowLogoutModal: false,
};

const logoutModalSlice = createSlice({
  name: 'logoutmodal',
  initialState,
  reducers: {
    onShowLogOutModal: state => {
      state.isShowLogoutModal = true;
    },
    onHideLogOutModal: state => {
      state.isShowLogoutModal = false;
    },
  },
});

export const { onHideLogOutModal, onShowLogOutModal } =
  logoutModalSlice.actions;

export default logoutModalSlice.reducer;
